import { gql } from '@apollo/client';

export const REDEEM_CODE_REWARD_FRAGMENT = gql`
  fragment RedeemCodeRewardFragment on LevelReward {
    __typename
    ... on Currency {
      amount
    }
    ... on CurrencyBoost {
      amount
      boostType
    }
    ... on CurrencyUnlimitedBoost {
      amount
      unlimitedBoostType
    }
    ... on CurrencyCategoryFragment {
      amount
      category {
        id
      }
    }
    ... on CurrencyCategoryRandom {
      amount
    }
    ... on ContentPackReward {
      contentPack {
        id
      }
    }
    ... on AppSkin {
      id
    }
    ... on Sticker {
      id
    }
    ... on ProfileFrame {
      id
    }
    ... on Badge {
      id
      name
    }
    ... on Poster {
      id
    }
    ... on Emoji {
      id
    }
    ... on EmojiPack {
      id
    }
  }
`;

export const REDEEM_CODE_FRAGMENT = gql`
  fragment RedeemCodeFragment on RedeemCode {
    id
    code
    successMessage
    startDate
    endDate
    filterUserIds
    filterAppVersion
    filterSubscriptionTier
    filterPlatform
    created
    updatedAt
    rewards {
      ...RedeemCodeRewardFragment
    }
  }
  ${REDEEM_CODE_REWARD_FRAGMENT}
`;

export const LIVEOPS_REDEEM_CODES_QUERY = gql`
  query getLiveOpsRedeemCodes {
    liveOps {
      id
      redeemCodes {
        ...RedeemCodeFragment
      }
    }
  }
  ${REDEEM_CODE_FRAGMENT}
`;

export const CREATE_REDEEM_CODE = gql`
  mutation createRedeemCode(
    $code: String!
    $successMessage: String
    $startDate: Date!
    $endDate: Date
    $filterUserIds: [ID!]
    $filterAppVersion: String
    $filterSubscriptionTier: UserSubscriptionTier
    $filterPlatform: RedeemCodePlatform
    $rewards: [LevelRewardInput!]!
  ) {
    createRedeemCode(
      code: $code
      successMessage: $successMessage
      startDate: $startDate
      endDate: $endDate
      filterUserIds: $filterUserIds
      filterAppVersion: $filterAppVersion
      filterSubscriptionTier: $filterSubscriptionTier
      filterPlatform: $filterPlatform
      rewards: $rewards
    ) {
      ...RedeemCodeFragment
    }
  }
  ${REDEEM_CODE_FRAGMENT}
`;

export const UPDATE_REDEEM_CODE = gql`
  mutation updateRedeemCode(
    $id: ID!
    $code: String
    $successMessage: String
    $startDate: Date
    $endDate: Date
    $filterUserIds: [ID!]
    $filterAppVersion: String
    $filterSubscriptionTier: UserSubscriptionTier
    $filterPlatform: RedeemCodePlatform
    $rewards: [LevelRewardInput!]
  ) {
    updateRedeemCode(
      id: $id
      code: $code
      successMessage: $successMessage
      startDate: $startDate
      endDate: $endDate
      filterUserIds: $filterUserIds
      filterAppVersion: $filterAppVersion
      filterSubscriptionTier: $filterSubscriptionTier
      filterPlatform: $filterPlatform
      rewards: $rewards
    ) {
      ...RedeemCodeFragment
    }
  }
  ${REDEEM_CODE_FRAGMENT}
`;

export const DELETE_REDEEM_CODE = gql`
  mutation deleteRedeemCode($id: ID!) {
    deleteRedeemCode(id: $id)
  }
`;
